import React from 'react'

import { Formik } from 'formik'

import { Col, Row } from '_zari/core'

import AfectacionesCompraConstant from 'constants/afectacionesCompra'

import { IdGen, RounderUtil } from 'utils'

import * as FormGroups from './formGroups'

const ResumenMontosSection = ({ innerRef, detalles, incluyeIGV }) => {
  const [keyFormik, setKeyFormik] = React.useState(IdGen.newId())

  const formInitialValues = React.useMemo(() => {
    setKeyFormik(IdGen.newId())

    let importeGravado = 0
    let importeIgv = 0
    let importeNoGravado = 0
    let importeOtros = 0
    let importeTotal = 0

    let detalle = null

    for (let i = 0; i < detalles.length; i++) {
      detalle = detalles[i]

      const innerMontoVariante = RounderUtil.roundTwoDecimals(parseFloat(detalle.subTotal))

      if (detalle.afectacion === AfectacionesCompraConstant.GRAVADO_A_AMBOS) {
        importeGravado = RounderUtil.roundTwoDecimals(importeGravado + innerMontoVariante)
        importeIgv = RounderUtil.roundTwoDecimals(importeIgv + detalle.igv)
      } else if (detalle.afectacion === AfectacionesCompraConstant.GRAVADO_A_GRAVADO) {
        importeGravado = RounderUtil.roundTwoDecimals(importeGravado + innerMontoVariante)
        importeIgv = RounderUtil.roundTwoDecimals(importeIgv + detalle.igv)
      } else if (detalle.afectacion === AfectacionesCompraConstant.GRAVADO_A_NO_GRAVADO) {
        importeGravado = RounderUtil.roundTwoDecimals(importeGravado + innerMontoVariante)
        importeIgv = RounderUtil.roundTwoDecimals(importeIgv + detalle.igv)
      } else if (detalle.afectacion === AfectacionesCompraConstant.NO_GRAVADO) {
        importeNoGravado = RounderUtil.roundTwoDecimals(importeNoGravado + innerMontoVariante)
      } else if (detalle.afectacion === AfectacionesCompraConstant.OTROS) {
        importeOtros = RounderUtil.roundTwoDecimals(importeOtros + innerMontoVariante)
      }
    }

    let igvTotalGravado = 0

    if (incluyeIGV) {
      igvTotalGravado = RounderUtil.roundTwoDecimals(importeGravado * 0.18)
    }

    importeTotal = RounderUtil.roundTwoDecimals(importeGravado + igvTotalGravado + importeNoGravado + importeOtros)

    return {
      importeGravado,
      importeNoGravado,
      importeOtros,
      importeIgv: igvTotalGravado,
      importeTotal
    }
  }, [detalles, incluyeIGV])

  return (
    <Formik key={keyFormik} initialValues={formInitialValues} innerRef={innerRef}>
      {({ values }) => (
        <Row>
          <Col md={5} />
          <Col md={7}>
            <Row>
              <Col md={6}>
                <FormGroups.ImporteGravadoFormGroup iValue={values.importeGravado} />
                <FormGroups.ImporteNoGravadoFormGroup iValue={values.importeNoGravado} />
                <FormGroups.ImporteOtrosFormGroup iValue={values.importeOtros} />
              </Col>
              <Col md={6}>
                <FormGroups.ImporteIgvFormGroup iValue={values.importeIgv} />
                <FormGroups.ImporteTotalFormGroup iValue={values.importeTotal} />
              </Col>
            </Row>
          </Col>
        </Row>
      )}
    </Formik>
  )
}

export default React.memo(ResumenMontosSection)
